import * as React from "react";
const SvgSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 172, height: 166, viewBox: "0 0 172 166", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.5 3.5H168.5V162.5H3.5V3.5Z", stroke: "#278cc9", strokeWidth: 7 }));
export default SvgSquare;
